import { FC } from "react";
import { BaseTable2, Modal } from "../../../TrueUI";
import { BaseTable2Properties } from "../../../TrueUI/Tables/BaseTable2/TableProperties";
import { useBaseTable } from "../../../../hooks/useBaseTable";

export type InsuredDividendPaymentModalConfig = {
  insuredId?: number;
  progranDividendId?: number | null;
  isOpen?: boolean | null;
  setIsOpen?: (open: boolean) => void;
};

type InsuredDividendPaymentModalProps = {
  modalConfig?: InsuredDividendPaymentModalConfig;
  setIsOpen?: (open: boolean) => void;
};

const tableName = "InsuredDividendPayment";
const InsuredDividendPaymentModal: FC<InsuredDividendPaymentModalProps> = ({
  modalConfig,
  setIsOpen,
}) => {
  const closeModal = () => {
    setIsOpen?.(false);
  };

  const tableConfiguration: BaseTable2Properties = {
    name: tableName,
    getURL: `api/InsuredDividendPayment/GetInsuredDividendPaymentsTable?insuredId=${modalConfig?.insuredId}&progranDividendId=${modalConfig?.progranDividendId}`,
    toolbarOptions: { hideToolbar: true },
    advancedOptions: { paginate: false },
    columnOptions: [{ fieldName: "Amount", align: "right" }],
  };

  useBaseTable(tableConfiguration);

  return (
    <Modal
      id="insuredDividendPaymentModal"
      title="Dividend Payment"
      open={modalConfig?.isOpen ?? false}
      showCloseButton
      cancelEvent={closeModal}
      closeEvent={closeModal}
    >
      <div>
        <BaseTable2 name={tableName} />
      </div>
    </Modal>
  );
};

export default InsuredDividendPaymentModal;
